<!-- 全站的選單．頁首選單： pc版選單 & md版漢堡選單 -->
<!-- 以下為模版，如要修變此模版css、js請寫在這 -->
<!-- 有使用此模版的檔案：themes/frontend/partials/site/header.htm -->

<template>
  <div class="site-header">
    <div class="container">
      <!-- md選單  -->
      <div ref="mobileMenu" v-viewport-condition="'< md'" class="mobile-menu">
        <div class="button-toggle-menu" @click="toggleMobileMenu">
          <i class="icon-menu" />
        </div>
        <div class="center">
          <!-- 套用logo模版 -->
          <slot name="logo" />
          <slot name="logo_ionex" />
        </div>
        <div class="menu-content" style="display: none">
          <!-- 套用md版選單模版 -->
          <slot name="mobile">
            <slot name="Activity_nav">
              <!-- <slot name="Activity_nav_even"><li><a href="https://www.ionex.com.tw/" target="_blank" data-ga-label="MobileMenu" alt="活動專區/Ionex">Ionex</a></li></slot> -->
            </slot>
          </slot>
        </div>
      </div>

      <!-- pc選單 -->
      <div v-viewport-condition="'> md'" class="main-menu">
        <div class="menu-leftItem">
          <!-- <img alt src="@/assets/site/header-logo.png" /> -->
          <!-- 套用logo模版 -->
          <slot name="logo" />
        </div>
        <div v-viewport-condition="'> md'" class="menu-centerItem">
          <!-- 套用pc版選單模版 -->
          <slot name="main" />
        </div>
        <div v-viewport-condition="'> md'" class="menu-rightItem">
          <!-- 跳出提醒訊息 -->
          <!-- <a title="ionex" class="top-nav-brand" href="https://www.ionex.com.tw/" @click.prevent="isOpenFn('https://www.ionex.com.tw/')"> -->
          <!-- 不跳出提醒訊息 -->
          <a title="ionex" class="top-nav-brand" href="https://www.ionex.com.tw/" data-ga-label="to-ionex">
            <slot name="logo_ionex" />
          </a>
        </div>
      </div>
    </div>
    <openNewWindow :isopen="openHref.isOpen" :openhref="openHref.openHref" @close_modal="closeModal" />
  </div>
</template>

<script>
import openNewWindow from '../ui/openNewWindow.vue'

export default {
  name: 'TopMenu',
  components: {
    openNewWindow,
  },
  data: () => ({
    current: {
      mobileMenuVisible: false, // 給v-show的初始值，之後會由js來修改.menu-content的屬性值
    },
    openHref: {
      isOpen: false,
      openHref: '',
    },
  }),
  watch: {
    'current.mobileMenuVisible'(visible) {
      if (visible) {
        document.documentElement.classList.add('mobile-menu-open')
      } else {
        document.documentElement.classList.remove('mobile-menu-open')
      }
    },
  },
  mounted() {
    const vm = this
    $('.menu-content').css('display', 'none')

    $('.menu-content ul li a').on('click', function () {
      $(this).parent().toggleClass('open')
      $(this).parent().siblings().removeClass('open')
    })

    $('.menu-content ul li ul li a').on('click', function () {
      $('.menu-content').css('display', 'none')
    })

    // Fix Scrolling Bug
    $('.main-body').scrollTop(0)

    // 監聽所有外連到ionex官網的項目
    $('.topMenu-checkHref').on('click', function (e) {
      e.preventDefault()
      e.stopPropagation()
      vm.isOpenFn()
    })
    $('.topMenu-openNewWindow').on('click', function (e) {
      e.preventDefault()
      e.stopPropagation()
      ga('send', 'event', location.pathname, '汰舊換新查詢', '汰舊換新查詢')
      gtag('event', '汰舊換新查詢', {'event_category': location.pathname,'event_label': '汰舊換新查詢'});
      window.open(
        this.href,
        '汰舊換新查詢',
        'left=20,top=20,width=550,height=450,olbar=no,location=no,directories=no,status=no,history=no,resizable=0,scrollbars=0'
      )
    })
  },
  methods: {
    toggleMobileMenu() {
      // this.current.mobileMenuVisible ^= true
      const displayVlue = $('.menu-content').css('display')
      if (displayVlue === 'none') {
        $('.menu-content').css('display', 'block')
      } else {
        $('.menu-content').css('display', 'none')
      }
    },
    isOpenFn(href = 'https://www.ionex.com.tw/') {
      // 會與openNewWindow元件有關：打開訊息框
      this.openHref.isOpen = true
      this.openHref.openHref = href
    },
    closeModal(isOpenVlue) {
      // 會與openNewWindow元件有關：關掉訊息框
      this.openHref.isOpen = isOpenVlue
    },
  },
}
</script>

<style lang="stylus">
html.mobile-menu-open
  @media screen and (max-width 767px)
    &, body
      overflow hidden !important
</style>

<style lang="stylus" scoped>
$colorDefault = #919191
$colorActive = #333333

.site-header
  font-family '微軟正黑體'
  background white
  height 60px
  color $colorDefault
  width 100vw
  border-bottom 1px solid #EDEDED
  @media (max-width 767px)
    // position fixed
    // left 0
    // right 0

.main-menu, .mobile-menu
  width 100%
  font-size 1.44em
  display flex
  justify-content space-around
  align-items center
  height 60px
  .menu-leftItem,.menu-rightItem,.menu-centerItem
    clear both
    flex 0 0 auto
    @media screen and (-ms-high-contrast active), (-ms-high-contrast none)
      width 100% // IE11 BUG

  .menu-centerItem
    > *
      display inline-block
      padding 1em
      @media screen and (max-width 1024px)
        padding 1vw 1.5vw

.main-menu
  a
    color $colorDefault
    font-weight bold
    &:hover
      color $colorActive
  img
    max-width 200px
    height auto
  img.logo_ionex
    max-width 161px

.center
  align-self center
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;
  @media (max-width 550px)
    justify-content: flex-end;
  img
    width 40vw
    max-width 200px
    height auto
  img.logo_ionex
    width: 35vw;
    max-width 180px
</style>

<style lang="stylus">
$colorRed = #F4000A

gradient-menu-light()
  background-image -moz-linear-gradient(top, rgba(255, 255, 255, .5) 0%, rgba(246, 246, 246, .27) 47%, rgba(255, 255, 255, 0) 100%)
  background-image -webkit-linear-gradient(top, rgba(255, 255, 255, .5) 0%, rgba(246, 246, 246, .27) 47%, rgba(255, 255, 255, 0) 100%)
  background-image linear-gradient(to bottom, rgba(255, 255, 255, .5) 0%, rgba(246, 246, 246, .27) 47%, rgba(255, 255, 255, 0) 100%)

trangle($height)
  content ''
  display block
  position absolute
  right 1rem
  margin-top ($height / 2) * -1
  top 50%

trangleUp($width, $height, $color)
  trangle($height)
  width 0
  height 0
  border-style solid
  border-width 0 ($width / 2) $height ($width / 2)
  border-color transparent transparent $color transparent
  line-height 0px

trangleRight($width, $height, $color)
  trangle($height)
  width 0
  height 0
  border-style solid
  border-width ($width / 2) 0 ($height / 2) $width
  border-color transparent transparent transparent $color
  line-height 0px

trangleDown($width, $height, $color)
  trangle($height)
  width 0
  height 0
  border-style solid
  border-width $height ($width / 2) 0 ($width / 2)
  border-color $color transparent transparent transparent
  line-height 0px

.mobile-menu
  user-select none
  .button-toggle-menu
    padding .5em
    cursor pointer
    // position absolute
    // left 0
    // top 0
    // bottom 0
    padding 1.2rem
    font-size 2rem
  .menu-content
    position fixed
    left 0
    right 0
    bottom 0
    top 60px
    z-index 100
    padding-bottom 100px
    background-color rgba(0, 0, 0, .8)
    height calc(100vh - 40px)
    overflow scroll
    ul, li
      padding 0
      display block
    li
      display block
      padding 0
      a
        display block
        min-height 60px
        text-align left
        background-color #D8D8D8
        border-radius 0
        line-height 60px
        z-index 50
        position relative
        padding-top 0
        padding-bottom 0
        padding-left 1em
        padding-right 1em
        font-size 1.2em
        gradient-menu-light()
        @media (max-width 400px)
          font-size 5.5vw
        &.btn-black
          background-color #333
        &.btn-red
          background-color $colorRed
    // First layer
    > ul
      display block
      margin-bottom 150px
      > li > a
        font-weight bold
        font-size 19px
        &:after
          trangleDown(10px, 8px, white) !important
      // Second layer
      > li > ul a
        padding-left 3.2em
        display none
      > li.open > a
        background #898989
        color white
      > li.open > ul a
        display block
      li.active > a
        position relative
        &:after
          content ''
          display block
          position absolute
          bottom -15px
          margin-left 45%
          trangleUp(20px, 20px, $colorRed)
      > li.active > ul
        opacity 1
        transform translateY(0%)
        z-index 20
        pointer-events all
</style>
